import { render } from "./LanguageSelection.vue?vue&type=template&id=4baa1f78"
import script from "./LanguageSelection.vue?vue&type=script&lang=js"
export * from "./LanguageSelection.vue?vue&type=script&lang=js"
script.render = render

export default script